import React from "react";
import { format } from "date-fns";
import { X } from "lucide-react";
import { ProductCard } from "@/components/booking/ProductCard";

export const OutOfStockModal = ({ open, onClose, unavailableProduct, alternatives, onSelect, cart, range }) => {
  if (!open) return null;
  const dateLabel = range?.from && range?.to
    ? `${format(range.from, "MMM d")} → ${format(range.to, "MMM d, yyyy")}`
    : "your dates";
  return (
    <div
      className="fixed inset-0 z-[100] bg-[#040A0F]/85 backdrop-blur-md flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="oos-modal"
    >
      <div
        className="glass max-w-4xl w-full max-h-[90vh] overflow-y-auto p-6 md:p-8 relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-[#B9C8D5] hover:text-[#FFD166] p-2"
          data-testid="oos-modal-close"
          aria-label="Close"
        >
          <X className="w-5 h-5" />
        </button>
        <div className="pr-10">
          <p className="eyebrow text-[#FFD166]">Sold out on {dateLabel}</p>
          <h3 className="font-serif text-3xl md:text-4xl mt-2 text-[#F6F1E4] leading-tight">
            Unfortunately, {unavailableProduct?.name || "this item"} isn't available for your dates.
          </h3>
          <p className="text-[#B9C8D5] mt-3">
            Not to worry — here are the items we still have in stock for your dates. Pick a magical alternative below.
          </p>
        </div>

        {alternatives.length === 0 ? (
          <div className="mt-8 text-center text-[#B9C8D5] py-10 border border-dashed border-[#FFD166]/25 rounded-2xl" data-testid="oos-modal-empty">
            We're fully booked for those exact dates. Try adjusting your date range and we'll show you everything available.
          </div>
        ) : (
          <div className="mt-8 grid md:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="oos-modal-alternatives">
            {alternatives.map((p) => (
              <ProductCard key={p.id} p={p} onSelect={onSelect} selectedQty={cart[p.id] || 0} range={range} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
